import '../css/languages.css';
import {langs} from '../data/langs'

const Languages = () => {
    return (
        <div className='languages-div'>
            <div className='languages'>
                <h2>Languages I use</h2>
            </div>
            <div className='icons'>

                {
                    langs.map((lang) => {
                        var name = lang.name;
                        return (
                            <div key={lang.id} className='each-lang-div'>
                            <img src={require(`../assets/languages/${name}.png`)} alt={lang.name}/>
                            </div>
                        );
                    })
                }               
             
            </div>
        </div>
    );
}

export default Languages;